/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import './IndustryPage.scss';

export default function IndustryPage() {
  const { t, i18n } = useTranslation(['industry_page', 'community_page', 'notifications']);
  const { industryKey } = useParams();
  const [industryData, setIndustryData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo({
      left: 0,
      top: 0,
      behavior: 'instant',
    });
  }, []);

  useEffect(() => {
    const header = document.querySelector('.Header.fixed');
    const industryPage = document.querySelector('.IndustryPage');
    const footer = document.querySelector('.Footer');

    if (header && industryPage && footer) {
      const minimumRequiredHeight = document.documentElement.clientHeight - (header.offsetHeight + footer.offsetHeight);
      industryPage.style.minHeight = `${minimumRequiredHeight}px`;
    }
  }, []);

  useEffect(() => {
    if (industryKey) {
      setLoading(true);
      fetch(`/enterprises/${i18n.language}.json`)
        .then((response) => response.json())
        .then((data) => {
          if (data[industryKey]) {
            setIndustryData(data[industryKey]);
          }
          setLoading(false);
        });
    }
  }, [industryKey, i18n.language]);

  if (loading) {
    return (
      <section className="IndustryPage">
        <div className="wrapper">
          <div className="industry-page-content">
            <div className="loading">{t('loading')}</div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="IndustryPage">
      <div className="wrapper">
        <div className="industry-page-content">
          <div className="industry-page-content-top-row">
            <a
              className="previous-page-link"
              href={
                i18n.languages[0] === 'en'
                  ? '/en/community/'
                  : '/community/'
              }
            >
              {t('previous')}
            </a>
            <h1 className="heading-one">
              {t(`community_page:industries.${industryKey}`)}
            </h1>
          </div>

          {industryData.length > 0 ? (
            <div className="enterprises-list">
              {industryData.map((company, index) => (
                <div key={`${industryKey}-${company.company_name}`} className="enterprise-item">
                  <a
                    href={`/community/${industryKey}/${index + 1}/`}
                    className="enterprise-card-link"
                  >
                    <div className="enterprise-card">
                      <div className="company-logo">
                        <img
                          src={
                            company.logo && company.logo.trim() !== ''
                              ? `/enterprises/logos/${company.logo}`
                              : '/logo_big.png'
                          }
                          alt={`${company.company_name} logo`}
                          loading="lazy"
                        />
                      </div>
                      <h3 className="company-name">{company.company_name}</h3>

                      {company.website && (
                        <div className="company-info">
                          <span className="info-label">
                            {t('website')}
                          </span>
                          <span className="website-text">
                            {company.website}
                          </span>
                        </div>
                      )}

                      {company.contact_phones && (
                        <div className="company-info">
                          <span className="info-label">
                            {t('phone')}
                          </span>
                          <span className="phone-number">{company.contact_phones}</span>
                        </div>
                      )}
                    </div>
                  </a>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-data">
              <p>{t('no_companies_found')}</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
